/**
 * Owner: Masa Bayu
 * File: typography-codes.ts
 * Date:Time: 2026-09-19 18:07
 * Description: Typography role ids aligned with QXTypographySystem (GL-06).
 */
/**
 * Must stay aligned with `@qx/ui` QX_TYPOGRAPHY_ROLES — mapping layer, not a fork.
 * Do not invent parallel roles like "arabic-body".
 */
export const QX_LANGUAGE_TYPOGRAPHY_ROLES = [
    'display',
    'title',
    'heading',
    'subheading',
    'body',
    'body-emphasis',
    'caption',
    'label',
    'quote',
    'footnote',
];
export const QX_TYPOGRAPHY_MODEL_VERSION = '1.0.0';
export const QX_FALLBACK_SLOTS = [
    'author',
    'theme',
    'script_fallback',
    'platform',
    'last_resort',
];
export function isQxLanguageTypographyRole(value) {
    return (typeof value === 'string' &&
        QX_LANGUAGE_TYPOGRAPHY_ROLES.includes(value));
}
export function isQxFallbackSlot(value) {
    return (typeof value === 'string' &&
        QX_FALLBACK_SLOTS.includes(value));
}
//# sourceMappingURL=typography-codes.js.map